package com.sddamico.swigmore.ds

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.CSSMediaQuery
import org.jetbrains.compose.web.css.StylePropertyValue
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.dom.Div

/** Swigmore Poll — motion. Content settles in rather than popping; nothing moves for reduced-motion users. */
object SwMotion {
  const val enterKeyframes = "sw-enter"
  const val fadeInKeyframes = "sw-fade-in"
  const val pulseKeyframes = "sw-pulse"
  const val shimmerKeyframes = "sw-shimmer"

  val reducedMotion = CSSMediaQuery.MediaFeature("prefers-reduced-motion", StylePropertyValue("reduce"))
}

@InitSilk
fun initSwMotion(ctx: InitSilkContext) {
  ctx.stylesheet.registerKeyframes(SwMotion.enterKeyframes) {
    from { Modifier.css("opacity" to "0", "transform" to "translateY(6px)") }
    to { Modifier.css("opacity" to "1", "transform" to "none") }
  }
  ctx.stylesheet.registerKeyframes(SwMotion.fadeInKeyframes) {
    from { Modifier.css("opacity" to "0") }
    to { Modifier.css("opacity" to "1") }
  }
  ctx.stylesheet.registerKeyframes(SwMotion.pulseKeyframes) {
    from { Modifier.css("opacity" to ".55") }
    to { Modifier.css("opacity" to "1") }
  }
  // One pass across, then a rest, so the highlight reads as a glint rather than a loop.
  ctx.stylesheet.registerKeyframes(SwMotion.shimmerKeyframes) {
    from { Modifier.css("background-position" to "150% 0") }
    45.percent { Modifier.css("background-position" to "-50% 0") }
    to { Modifier.css("background-position" to "-50% 0") }
  }
}

val RevealStyle = CssStyle {
  base { Modifier.css("animation" to "${SwMotion.enterKeyframes} 220ms cubic-bezier(.2,.7,.3,1) both") }
  cssRule(SwMotion.reducedMotion) { Modifier.css("animation" to "none") }
}

/** Content that rises into place as it mounts: a page's body once its data is in. */
@Composable
fun Reveal(modifier: Modifier = Modifier, content: @Composable () -> Unit) {
  Div(attrs = RevealStyle.toModifier().then(modifier).toAttrs()) { content() }
}
